import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";

// Crea el contexto
const FieldConfigurationContext = createContext(null);

// Proveedor del contexto
export function FieldConfigurationProvider({ children, fieldConfiguration }) {
  return (
    <FieldConfigurationContext.Provider value={fieldConfiguration}>
      {children}
    </FieldConfigurationContext.Provider>
  );
}

// Hook para acceder al valor del contexto
export function useFieldConfiguration() {
  return useContext(FieldConfigurationContext);
}

FieldConfigurationProvider.propTypes = {
  children: PropTypes.any,
  fieldConfiguration: PropTypes.any,
};
